import React from "react";
import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found | Regency Inn & Suites" description="The page you are looking for could not be found." path="/404" />
      <section className="min-h-[80vh] flex items-center justify-center bg-bone px-6" data-testid="not-found">
        <div className="text-center">
          <span className="font-serif text-8xl text-amber">404</span>
          <h1 className="font-serif text-4xl text-forest mt-4">This page checked out early.</h1>
          <p className="text-stone mt-4 max-w-md mx-auto">
            The page you're looking for may have moved. Let's get you back to a warm welcome.
          </p>
          <Link to="/" data-testid="notfound-home" className="mt-8 inline-flex rounded-full bg-forest text-bone px-8 py-4 text-sm font-medium hover:bg-amber transition-colors">
            Return Home
          </Link>
        </div>
      </section>
    </>
  );
}
